import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { AccessDenied } from '../pages';
import {
  isAuthenticated, userCan,
} from '../api/helper';
import { ROUTE_LOGIN } from '../config/routes';
import { Loader } from '../components/layout/Loader/Loader';

class ProtectedRouteComponent extends Component {
state = {
  isLoading: true,
}

componentDidUpdate(){
  const isLoading = this.props?.user?.loading;
  if(this.state.isLoading !== isLoading)
  this.setState({isLoading: isLoading});
}

getUserLoading=()=>{
  const {user} = this.props;

  return user?.loading || this.state.isLoading;
}
  
  render() {
    const { component: Component, ...props } = this.props;
    // Receive the ACL list to have access on this route
    const { user, acls } = this.props;

    let userIsAuthenticated = isAuthenticated();
    let hasAccess = userIsAuthenticated;

    if (user && acls && acls.length) {
      hasAccess = hasAccess && userCan( acls )
    }

    return (
      <Route
        {...props}
        render={props => {
          return (
            this.getUserLoading() ? <Loader/> :
              hasAccess ?
                <Component {...props} /> :
                (
                  userIsAuthenticated ?
                    <AccessDenied/> :
                    <Redirect to={{
                      pathname: ROUTE_LOGIN,
                      state: { from: props.location }
                    }}/>
                )
          )
        }}
      />
    )
  }
}

const mapStateToProps = state => ( {
  user: state.user.profile || null,
  loading: state.loading.pendingRequests || 0,
} );

const ProtectedRoute = connect( mapStateToProps )( withRouter( ProtectedRouteComponent ) );

export default withRouter( ProtectedRoute );
